export default __webpack_public_path__ + "static/media/Meal_Planner.11960870.png";